module.exports = __webpack_public_path__ + "img/fc_img.d39c3014.jpg";